import { DEVICES } from '../../constants'

export const getRedirectOptions = (admon, activeDynamicLayout) => ({
  ...admon,
  fcid: admon.fcid[activeDynamicLayout],
  device: activeDynamicLayout === DEVICES.DESKTOP ? 'd' : 'm'
})
